import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import LnIcon from "components/LnIcon";
import classes from './lncard.module.scss';

/**
 * LnCollapseGroup
 * @module components/LnCard/LnCollapseGroup
 * @return a card with a CollapseCard.
 *
 * @param {object} props keys: group, children & isOpen
 */
const LnCollapseGroup = (props) => {
    const g = props.group
    const [isOpen, setIsOpen] = useState(props.isOpen || false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <div>
            <div className={[classes['ln-group-card-header'], 'card-header', "bg-light"].join(' ')} onClick={toggle}>
                <h3>{g.Name}</h3>
                {isOpen ? <LnIcon className={[ classes[ 'toggle-icon' ], 'natural' ].join(' ')} name="minus" /> : <LnIcon className={[ classes[ 'toggle-icon' ], 'natural' ].join(' ')} name="plus" />}
            </div>
            <div className="card-body">
                <Collapse isOpen={isOpen}>
                    {props.children}
                </Collapse>
            </div>
        </div>
    )
}

export { LnCollapseGroup };
